var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":_vm.$t('cart.address.address')}},_vm._l((_vm.addressList),function(address){return _c('div',[_c('AddressItem',{attrs:{"address":address},on:{"onAddressSelected":function($event){_vm.selectAddress(address)}}})],1)}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4758ac68","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Cart/components/AddressList.vue
// module id = null
// module chunks = 